<div class="header" >
	<div class="content" [ngsRevealSet]="{ reset:false, scale:1, distance: '20px'}" [ngsInterval]="50" [ngsSelector]="'.pageTitle'">
		<div class="contentInner">
			<div class="pageTitle">
			<h1 class="headline">Pricing and plans</h1>
			</div>
		</div>
	</div>
</div>
<div class="content">

	<div class="priceList">
    <div class="priceContainer basic">
      <h2 class="price">
        <div class="plan">
          <div class="planName">Basic plan</div>
          <span class="priceValue">Free</span> forever.
        </div>
      </h2>
      <div class="priceDetails">
        <p>Enjoy a read-only display of your meeting rooms for free.</p>
        <ul>
          <li class="yes2">Microsoft 365 integration</li>
          <li class="yes2">Google Workspace integration</li>
          <li class="yes2">Schedule display</li>
        </ul>
        <p>Free to download from your favorite store:</p>
        <div class="storeButtonContainer">
          <!--          <h3>Try all the features of Dash free for one month</h3>-->
          <a href="https://apps.apple.com/us/app/dash-meeting-room-display/id1481443382"><img ngSrc="../assets/images/app-store-badge.svg" width="133" height="40" alt="Download on App Store"></a>
          <a href="https://play.google.com/store/apps/details?id=nz.co.aptsoftware"><img ngSrc="../assets/images/play-store-badge.svg" width="133" height="40" alt="Download on Play Store"></a>
          <a href="https://www.amazon.com/gp/product/B0D4DY15WY"><img ngSrc="../assets/images/amazon-store-badge.svg" width="133" height="40" alt="Download on Amazon App Store"></a>
        </div>
      </div>
    </div>
    <div class="priceContainer pro">
      <h2 class="price">
        <div class="banner">Most popular</div>
        <div class="plan">
          <div class="planName">Business plan</div>
          <span class="priceValue">$3.99<span class="currency">USD</span></span>per device per month.*
        </div>
      </h2>
      <div class="priceDetails">
        <div>
          <p>Enjoy everything included in our basic plan, plus:</p>

          <ul>
            <li class="yes2">Room schedule display</li>
            <li class="yes2">Room booking</li>
            <li class="yes2">Extending and ending meetings</li>
            <li class="yes2">Meeting check-in</li>
            <li class="yes2">Find free rooms</li>
            <li class="yes2">Custom branding</li>
          </ul>
          <p>Try it free for one month, get it from your favorite store:</p>
          <div class="storeButtonContainer">
            <!--          <h3>Try all the features of Dash free for one month</h3>-->
            <a href="https://apps.apple.com/us/app/dash-meeting-room-display/id1481443382"><img ngSrc="../assets/images/app-store-badge.svg" width="133" height="40" alt="Download on App Store"></a>
            <a href="https://play.google.com/store/apps/details?id=nz.co.aptsoftware"><img ngSrc="../assets/images/play-store-badge.svg" width="133" height="40" alt="Download on Play Store"></a>
            <a href="https://www.amazon.com/gp/product/B0D4DY15WY"><img ngSrc="../assets/images/amazon-store-badge.svg" width="133" height="40" alt="Download on Amazon App Store"></a>
          </div>
        </div>
        <p class="disclaimer">* The Apple App Store, Google Play Store, or Amazon App Store are responsible for converting the per-display price to your local currency.  To see the exact monthly charge in your local currency, please check the pricing information displayed in Dash on your device.</p>
      </div>
    </div>
    <div class="priceContainer enterprise">
      <h2 class="price">
        <div class="plan">
          <div class="planName">Enterprise plan</div>
          <span class="priceValue">Custom</span> pricing.
        </div>
      </h2>
      <div class="priceDetails">
        <p>Our enterprise plan gives you the ability to centrally manage your Dash display devices and their configuration.</p>
        <p>Enjoy everything included in our business plan, plus:</p>
        <ul>
          <li class="yes2">Central management <a class="extra-link" routerLink="/enterprise">Learn more</a></li>
          <li class="yes2">MDM Deployment</li>
          <li class="yes2">Web dashboard</li>
          <li class="yes2">Web display app</li>
          <li class="yes2">Invoice billing</li>
          <li class="yes2">Custom subscriptions</li>
        </ul>
        <a class="button" routerLink="/contact">Contact us</a>
      </div>
    </div>

  </div>

</div>
